'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_LineItem$() {
  this.aC9 = null;
  $n_Lapp_data_LineItem$ = this;
  this.aC9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_Ljava_text_DecimalFormat__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljava_text_DecimalFormat(), "#,###");
}
export { $c_Lapp_data_LineItem$ as $c_Lapp_data_LineItem$ };
$p = $c_Lapp_data_LineItem$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_LineItem$;
/** @constructor */
function $h_Lapp_data_LineItem$() {
}
export { $h_Lapp_data_LineItem$ as $h_Lapp_data_LineItem$ };
$h_Lapp_data_LineItem$.prototype = $p;
var $d_Lapp_data_LineItem$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_LineItem$, "app.data.LineItem$", ({
  E3: 1
}));
export { $d_Lapp_data_LineItem$ as $d_Lapp_data_LineItem$ };
var $n_Lapp_data_LineItem$;
function $m_Lapp_data_LineItem$() {
  if ((!$n_Lapp_data_LineItem$)) {
    $n_Lapp_data_LineItem$ = new $c_Lapp_data_LineItem$();
  }
  return $n_Lapp_data_LineItem$;
}
export { $m_Lapp_data_LineItem$ as $m_Lapp_data_LineItem$ };
//# sourceMappingURL=app.data.-Line-Item$.js.map
